import {useEffect, useMemo} from "react"
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext"
import {lexicalGetInitialEditorState} from "../actions/get-initial-editor-state"
import {ContentRTF} from "../@type"

type Props = {
    messageText?    : string        // is used if no messageRTF
    messageRTF?     : ContentRTF
}

const debug = false
// const debug = "EditorStateUpdate"

// special updater to modify editor state if messageText or messageRTF is changed
export default function EditorStateUpdate(props:Props) {
    const [editor]  = useLexicalComposerContext()

    // initial values on first render (never change)
    const messageText   = useMemo(()=>props.messageText, [])
    const messageRTF    = useMemo(()=>props.messageRTF, [])

    useEffect(() => {
        debug && console.log(debug, 'useEffect', props)

        // timeout is required to wait for the next frame
        const timeoutId = setTimeout(()=>{
            // check if messageText or messageRTF is changed
            if (props.messageText !== messageText || !_.isEqual(props.messageRTF, messageRTF)) {
                const initialEditorState = editor.parseEditorState(lexicalGetInitialEditorState(props.messageText, props.messageRTF))

                debug && console.log(debug, 'useEffect initialEditorState', initialEditorState)

                editor.setEditorState(initialEditorState)
            }
        },0)
        return () => {
            clearTimeout(timeoutId)
        }
    },[props.messageText, props.messageRTF])
    return null
}